export interface IEpiProps {
    heading: string
    headingDescription: string
    searchCtaText: string
    searchPlaceholderText: string
    memberDirectoryLinkText: string
    memberDirectoryLinkUrl: string
    allAAPContextText: string
    shopAAPContextText: string
    healthyChildrenContextText: string
    advancedSearchTipsTooltipLabelText: string
    advancedSearchTipsTooltipText: string
    noSearchResultsText: string
    shopSearchResultRetailPriceLabel: string
    shopSearchResultMemberPriceLabel: string
    shopSearchResultProductNumberLabel: string
    publicationsSearchResultLockIconsUrlsToExclude: string;
    healthyChildrenHeadingDescription: string;
    healthyChildrenHeading: string;
    healthyChildrenSearchPlaceholderText: string
    loadMoreCtaText: string
    generativeAIOverviewHeading: string
    generativeAIOverviewDisclaimer: string
    relatedQuestionsHeading: string
    shopHeading: string
    shopHeadingDescription: string
    shopSearchPlaceholderText: string
    filterResultsHeading: string
    noFiltersMessage: string
    resetFiltersText: string
    productTypeFiltersHeading: string
    priceFiltersHeading: string
    topicFiltersHeading: string
    creditTypeFiltersHeading: string
    filtersShowMoreText: string
    filtersShowLessText: string
}

export interface IVertexSearchPageAppProps {
    epiProps: IEpiProps
    showHealthyChildrenBranding: boolean
    healthyChildrenUrl: string
    googleVertexCommerceVisitorId: string
    disableGenerativeAIOverview: boolean
    disableGenerativeAIOverviewAllAAPContext: boolean
    disableGenerativeAIOverviewHealthyChildrenContext: boolean
    generativeAIOverviewForceEnglishLanguage: boolean
    recaptchaV3SiteKey: string
}

export interface IinitialState {
    epiProps: IEpiProps
    showHealthyChildrenBranding: boolean
    currentSearchContext: string
    searchResultsContainer: ISearchResultsContainer
    currentSearchQuery: string
    selectedShopFilters: ISelectedFilters
    selectedShopFiltersString: string //Used to format filters for Google Vertex API.
    healthyChildrenUrl: string
    googleVertexCommerceVisitorId: string
    disableGenerativeAIOverview: boolean
    disableGenerativeAIOverviewAllAAPContext: boolean
    disableGenerativeAIOverviewHealthyChildrenContext: boolean
    generativeAIOverviewForceEnglishLanguage: boolean
    recaptchaV3SiteKey: string
    facetsShowMoreState: IFacetsDisplayState
    facetsAccordionClosedState: IFacetsDisplayState

}

export class SearchContext {
    static AllAAP: string = "All AAP";
    static ShopAAP: string = "shopAAP";
    static HealthyChildren: string = "Healthy Children";
} 

export interface ISearchResult {
    title: string;
    url: string;
    snippet: string;
    documentName: string;
    citationTopic: string;
    publishDate: string;
    publishImageUrl: string;
    type: string;
    keywords: string[];
    memberPrice: string;
    retailPrice: string;
    productCode: string;
    id: string;
}

export interface ISearchResultsContainer {
    searchResults: ISearchResult[];
    searchAnswer: ISearchAnswer;
    nextPageToken: string;
    facets: IFacet[]; //Used for SHOP only.
    attributionToken: string; //Used for SHOP only.
}

export interface ISearchRequest {
    searchQuery: string;
    pageToken: string;
    currentSearchContext: string;
    shopFilters: string;
    currentShopFacets: IFacet[]; //All facets to display, if we do not need to retrieve new facets from the backend.
    disableGenerativeAIOverview: boolean; //Applies to All AAP and/or Healthy Children context(s).
    generativeAIOverviewForceEnglishLanguage: boolean; //Applies to All AAP and/or Healthy Children context(s). If true, English answers will be returned. Otherwise, Google will return the answer in the same language as the user's search query, to the best of its ability.
    recaptchaV3Token: string;
}
export interface ICitationSentence {
    citationSentenceText: string;
    citations: IReference[];
}

export interface IReference {
    snippet: string;
    url: string;
    title: string;
    publishDate: string;
}

export interface ISearchAnswer {
    fullAnswerText: string;
    citationSentences: ICitationSentence[];
    relatedQuestions: string[];
}

export interface IFacetValue {
    value: string;
    count: number;
}

export interface IFacet {
    key: string;
    values: IFacetValue[];
}

export interface ISelectedFilters {
    [key: string]: string[];
}

export interface IFacetsDisplayState {
    [facetKey: string]: boolean
}